module.exports = __webpack_public_path__ + "c7f485ebc666896ab11c75a0f392352e.svg";